<template>
  <div :class="classes">
    <place-detail v-show="showPlace" />
    <place-list v-show="showPlaceList" />
    <spot-marker-list v-show="showSpotMarkerList" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlaceDetail from './PlaceDetail'
import PlaceList from './PlaceList'
import SpotMarkerList from './SpotMarkerList'

export default {
  components: {
    PlaceDetail,
    PlaceList,
    SpotMarkerList
  },
  data () {
    return {
      block: 'hidden',
      show: false
    }
  },
  computed: {
    ...mapGetters({
      selectedPlace: 'drawer/getSelectedPlace',
      showPlaceFull: 'drawer/getShowPlaceFull',
      isOpen: 'drawer/getIsOpen',
      component: 'drawer/getComponent',
      forceOpen: 'drawer/getForceOpen'
    }),
    showPlace: function () {
      return this.component == 'PlaceDetail'
    },
    showPlaceList: function () {
      return this.component == 'PlaceList'
    },
    showSpotMarkerList: function () {
      return this.component == 'spotMarkerList'
    },
    drawerHeight: function () {
      if (this.showPlaceList || this.showSpotMarkerList ) {
        return 'h-52'
      } else  {
        return this.showPlaceFull ? 'h-96' : 'h-32'
      }
    },
    classes: function () {
      const base = ['transform', 'absolute', 'bg-white', 'bottom-0', 'w-full', 'ease-in-out', 'transition-all', 'duration-300', 'z-10', 'rounded-tl-lg', 'rounded-tr-lg', 'panel-shadow']
      base.push(this.forceOpen ? 'block' : this.block)
      base.push(this.forceOpen || this.show ? 'translate-y-0' : 'translate-y-all')
      base.push(this.drawerHeight)

      return base
    }
  },
  watch: {
    // NOTE: 上下にスライドする感じのトランジションを効かすために要素の表示タイミングを調整
    isOpen: function (val) {
      if (val) {
        this.block = 'block'
        setTimeout(() => {
          this.show = true
        }, 200)
      } else {
        setTimeout(() => {
          this.block = 'hidden'
        }, 400)
        this.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-shadow {
  box-shadow: 0px 3px 3px 3px rgb(0, 0, 0, 0.2);
}
</style>